<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="发布人" prop="nickname">
                <a-input v-model="queryParam.nickname" placeholder="请输入发布人名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="内容" prop="content">
                <a-input v-model="queryParam.content" placeholder="请输入内容" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="定位名称" prop="positionName">
                  <a-input v-model="queryParam.positionName" placeholder="请输入定位名称" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['dynamic:dynamic:add']">-->
<!--          <a-icon type="plus" />新增-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['dynamic:dynamic:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['dynamic:dynamic:remove']">
          <a-icon type="delete" />删除
        </a-button>
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['dynamic:dynamic:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
<!--        <table-setting-->
<!--          :style="{float: 'right'}"-->
<!--          :table-size.sync="tableSize"-->
<!--          v-model="columns"-->
<!--          :refresh-loading="loading"-->
<!--          @refresh="getList" />-->
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />

      <DynamicCommentList ref="commentList"/>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <div slot="imgUrl" slot-scope="text, record">
          <div style="margin-bottom: 10px" v-if="record.type == 2">
<!--            <div v-for="(item,index) in record.imgUrl" :key="index">-->
              <video :src="record.videoUrl" style="height: 80px" controls></video>
<!--            </div>-->
          </div>
          <div style="margin-bottom: 10px" v-else>
            <div v-for="(item,index) in record.imgUrl" :key="index">
              <img style="width: 80px;height: 80px;margin-right: 5px" v-image-preview :src="item" />
            </div>
          </div>

        </div>

        <span slot="isTop" slot-scope="text, record">
          <div >
            推荐：
           <a-switch @click="updateDynamicState(record)" v-model="record.isTop">
             <a-icon type="check" slot="checkedChildren"/>
             <a-icon type="close" slot="unCheckedChildren"/>
           </a-switch>
          </div>
        </span>

        <span slot="operation" slot-scope="text, record">
           <a @click="openComment(record)" v-hasPermi="['dynamic:dynamic:look']">
            查看评论
          </a>
<!--          <a-divider type="vertical" v-hasPermi="['dynamic:dynamic:edit']" />-->
<!--          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['dynamic:dynamic:edit']">-->
<!--           审核-->
<!--          </a>-->

          <a-divider type="vertical" v-hasPermi="['dynamic:dynamic:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['dynamic:dynamic:remove']">
            删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {pageDynamic, listDynamic, delDynamic, updateIsTop} from '@/api/dynamic/dynamic'
import CreateForm from './modules/CreateForm'
import DynamicCommentList from './modules/DynamicCommentList'
import { tableMixin } from '@/store/table-mixin'
import * as goods from "@/api/mall/goods";

export default {
  name: 'Dynamic',
  components: {
    CreateForm,
    DynamicCommentList
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        nickname: null,
        content: null,
        type: null,
        positionName: null,
        isTop: null,
        auditStatus: null,
        pageNum: 1,
        pageSize: 10,
        sortField: 'createTime',
        sortOrder: 'DESCEND'
      },
      columns: [
        // {
        //   title: '${comment}',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '#',
          dataIndex: 'id',
          align: 'center',
          width: 60,
          customRender:function (text, record, index) {
            return  (index + 1);
          }
        },

        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '发布人',
          dataIndex: 'nickname',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '内容',
          dataIndex: 'content',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '视频',
        //   dataIndex: 'videoUrl',
        //   ellipsis: true,
        //   align: 'center',
        //   scopedSlots: { customRender: 'videoUrl' }
        // },
        {
          title: '图片/视频',
          dataIndex: 'imgUrl',
          ellipsis: true,
          align: 'center',
          width: 165,
          scopedSlots: { customRender: 'imgUrl' }
        },
        {
          title: '类型',
          dataIndex: 'type',
          ellipsis: true,
          align: 'center',
          customRender:function (text, record, index) {
            if(text == 0) {
              return '纯文字';
            }else if(text == 1) {
              return '图片';
            } else if(text== 2){
              return '视频'
            }
          }
        },
        {
          title: '定位名称',
          dataIndex: 'positionName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '点赞数',
          dataIndex: 'likeNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '评论数',
          dataIndex: 'commentNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '是否推荐',
          dataIndex: 'isTop',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: 'isTop'}
        },
        // {
        //   title: '审核状态',
        //   dataIndex: 'auditStatus',
        //   ellipsis: true,
        //   align: 'center',
        //   customRender:function (text, record, index) {
        //     if(text == 1) {
        //       return '未审核';
        //     }else if(text == 2) {
        //       return '正常';
        //     } else {
        //       return '审核失败'
        //     }
        //   }
        // },
        {
          title: '插入时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    openComment(rowData) {
      this.$refs.commentList.open(rowData);
    },
    /** 查询用户动态列表 */
    getList () {
      debugger
      this.loading = true
     pageDynamic(this.queryParam).then(response => {
       debugger
       response.data.records.forEach(j=> {
         debugger
         if(j.imgUrl) {
           if(j.type == 1) {
             j.imgUrl = j.imgUrl.split(',')
           } else if(j.type == 2){
             j.imgUrl = [j.imgUrl]
           }
         }
       })
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },


    updateDynamicState(record){
      var that = this;
      console.log(record.state)
      let formData = JSON.parse(JSON.stringify(record))
      console.log(formData);
      let queryData = {
        id:formData.id,
        isTop:(formData.isTop)
      }
      updateIsTop(queryData).then((res) => {
        if (res.code == 20001) {
          that.$message.success(res.message)
          that.$emit('ok');
        } else {
            record.isTop = (queryData.isTop) ? false : true
          this.$message.warning(res.message)
        }
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      debugger
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        nickname: undefined,
        content: undefined,
        type: undefined,
        positionName: undefined,
        isTop: undefined,
        auditStatus: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delDynamic(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('dynamic/dynamic/export', {
            ...that.queryParam
          }, `用户动态_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
